import DOMPurify from "isomorphic-dompurify"
import markedKatex from "marked-katex-extension"

import { Marked } from "marked";
import { markedHighlight } from "marked-highlight";
import hljs from 'highlight.js';

const marked = new Marked(
  markedHighlight({
	emptyLangClass: 'hljs',
    langPrefix: 'hljs language-',
    highlight(code, lang) {
      const language = hljs.getLanguage(lang) ? lang : 'plaintext';
      return hljs.highlight(code, { language }).value;
    }
  })
);

marked.use(markedKatex({
  throwOnError: false,
  nonStandard: true
}));

export function processMarkdown(content: string, allowHTML: boolean = false): string {
    content = content.replaceAll(/[^\\]\$(\d+\.?,?)+(?! [\\+\-\*\/])\s/g, "\\$&");
    content = content.replaceAll(/<think>[^]*?<\/think>/g, "");
    content = content.replaceAll("\\(", "$").replaceAll("\\)", "$")
    // HACK: 1. doesn't turn into a list!
    if (content.endsWith("."))
        content = content.slice(0, content.length-1) + "\\."

    let html = marked.parse(content, {async: false});
    if (!allowHTML)
        html = DOMPurify.sanitize(html);

    // make images use absolute paths
    if (typeof window !== "undefined") {
        const baseUrl = window.location.origin + window.location.pathname.replace(/\/$/, "");
        const div = document.createElement("div");
        div.innerHTML = html;
        div.querySelectorAll("img").forEach(img => {
            const src = img.getAttribute("src");
            if (src && !/^https?:\/\//i.test(src) && !src.startsWith("/")) {
                img.setAttribute("src", `${baseUrl}/${src}`);
            }
        });
        html = div.innerHTML;
    }

    return html;
}

// for tts
export function toSpeechText(content: string) {
    const html = processMarkdown(content);
    const div = document.createElement("div")
    div.innerHTML = html;
    return div.innerText
}